/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} License_Manage_ButtonInputs */



/**
* | output |
* | --- |
* | "Manage licence" |
*
* @param {License_Manage_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_manage_button = /** @type {((inputs?: License_Manage_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_Manage_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gérer la licence")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lizenz verwalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gestisci licenza")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Управление лицензией")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gestionar licencia")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("管理许可证")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ライセンスを管理")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लाइसेंस प्रबंधित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerir licença")
	return /** @type {LocalizedString} */ ("Manage licence")
});